define("shared/components/shared/mavely/links/search", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@ember/utils", "@glimmer/component", "ember-concurrency", "later/utils/constants/segment-events", "later/utils/time-format", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _utils, _component2, _emberConcurrency, _segmentEvents, _timeFormat, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"ember-concurrency",0,"later/utils/constants/segment-events",0,"later/utils/time-format",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <form class="o--formWrapper u--p__lr__lg u--m__tb__md">
    <div class="o--inputAction--light u--flex u--flex__alignItems--center u--p__r__xs">
      {{svg-jar "search" class="o--icon o--inputAction__icon--left"}}
      <Input
        @type="search"
        @value={{@searchQuery}}
        class="o--inputAction__input u--p__tb u--ellipsis"
        data-qa-id="qa--mavely_links_search_box"
        data-test-id="link-search-input"
        placeholder={{t "mavely.links_modal.search.placeholder"}}
        {{on "input" (perform this.onSearch)}}
      />
  
      {{#if this.showNumberOfSearchResults}}
        {{#if this.hasSearchResults}}
          <span
            class="o--badge u--text--light u--m__r__md u--ws--noWrap"
            data-qa-id="qa--mavely_search_results"
            data-test-id="search-results-count"
          >
            {{t "mavely.links_modal.search.number_of_results" count=@numberOfLinks}}
          </span>
        {{else}}
          <span class="o--badge u--text--light u--m__r__md u--ws--noWrap" data-test-id="search-results-count-none">
            {{t "mavely.links_modal.search.number_of_results_none"}}
          </span>
        {{/if}}
        <Shared::Ui::Button @onClick={{@clearSearch}} @variant="unstyled" data-test-id="clear-search-button">
          {{svg-jar "close" class="o--icon o--inputAction__icon--right u--fadeIn--right"}}
        </Shared::Ui::Button>
      {{/if}}
    </div>
  </form>
  */
  {
    "id": "fu19+6nz",
    "block": "[[[10,\"form\"],[14,0,\"o--formWrapper u--p__lr__lg u--m__tb__md\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--inputAction--light u--flex u--flex__alignItems--center u--p__r__xs\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"search\"],[[\"class\"],[\"o--icon o--inputAction__icon--left\"]]]],[1,\"\\n    \"],[8,[39,1],[[24,0,\"o--inputAction__input u--p__tb u--ellipsis\"],[24,\"data-qa-id\",\"qa--mavely_links_search_box\"],[24,\"data-test-id\",\"link-search-input\"],[16,\"placeholder\",[28,[37,2],[\"mavely.links_modal.search.placeholder\"],null]],[4,[38,3],[\"input\",[28,[37,4],[[30,0,[\"onSearch\"]]],null]],null]],[[\"@type\",\"@value\"],[\"search\",[30,1]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showNumberOfSearchResults\"]],[[[41,[30,0,[\"hasSearchResults\"]],[[[1,\"        \"],[10,1],[14,0,\"o--badge u--text--light u--m__r__md u--ws--noWrap\"],[14,\"data-qa-id\",\"qa--mavely_search_results\"],[14,\"data-test-id\",\"search-results-count\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"mavely.links_modal.search.number_of_results\"],[[\"count\"],[[30,2]]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,1],[14,0,\"o--badge u--text--light u--m__r__md u--ws--noWrap\"],[14,\"data-test-id\",\"search-results-count-none\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"mavely.links_modal.search.number_of_results_none\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[8,[39,6],[[24,\"data-test-id\",\"clear-search-button\"]],[[\"@onClick\",\"@variant\"],[[30,3],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,0],[\"close\"],[[\"class\"],[\"o--icon o--inputAction__icon--right u--fadeIn--right\"]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@searchQuery\",\"@numberOfLinks\",\"@clearSearch\"],false,[\"svg-jar\",\"input\",\"t\",\"on\",\"perform\",\"if\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/mavely/links/search.hbs",
    "isStrictMode": false
  });
  let MavelyLinksSearchComponent = _exports.default = (_class = class MavelyLinksSearchComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "mavelyAffiliateLinks", _descriptor, this);
      _initializerDefineProperty(this, "segment", _descriptor2, this);
      /**
       * Event listener for when a user searches through links via the searchbar.
       * Function is called whenever the user presses a key that changes the value
       * of the searchbar.
       */
      _defineProperty(this, "onSearch", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const hasQuery = this.args.searchQuery.length > 0;
          if (hasQuery) {
            yield this._searchLinks.perform();
          }
        }
      }), null, "onSearch", "restartable"));
      _defineProperty(this, "_searchLinks", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const numberOfLinksAlreadyFetched = 0;
          const numberOfDebounceSeconds = 0.25;
          yield (0, _emberConcurrency.timeout)(_timeFormat.convert.seconds(numberOfDebounceSeconds).toMilliseconds());
          const mavelyLinksData = yield this.mavelyAffiliateLinks.fetchLinks.perform(this.args.mavelyProfile.id, numberOfLinksAlreadyFetched, this.mavelyAffiliateLinks.standardLimitPerRequest, undefined, this.args.searchQuery);
          this.args.setSearchResults(mavelyLinksData);
          this.trackSegmentEvent();
        }
      }), null, "_searchLinks", "restartable"));
    }
    get hasSearchResults() {
      return this.args.numberOfLinks > 0;
    }
    get showNumberOfSearchResults() {
      return (0, _utils.isPresent)(this.args.searchQuery) && !this.mavelyAffiliateLinks.fetchLinks.isRunning;
    }
    trackSegmentEvent() {
      this.segment.track(_segmentEvents.SegmentEventTypes.ClickedLinkinbioMavely, {
        click_type: 'search',
        mavely_account: this.args.mavelyProfile.email
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "mavelyAffiliateLinks", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MavelyLinksSearchComponent);
});